/* Site-wide motion layer (assets/hc-motion.css): section reveals, highlighter marks that draw in, count-up stats, yellow CTA sheen.
   Progressive enhancement only: nothing is hidden until this script runs, and it skips sections that animate themselves. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var main = document.querySelector('main');
  if (!main) return;

  // Sections with their own motion system (video pack, hooks, checklist, homepage reveals) are left alone.
  var OWN = /(^|\s)(hvp|hkl|hcl|hca|hch)[-_]|reveal|scroll-trigger/;
  function ownMotion(section) {
    if (OWN.test(section.className)) return true;
    return !!section.querySelector('[class*="reveal"], [class*="hvp-"], [class*="hkl-"], [class*="hcl-"], [class*="hca"], .scroll-trigger');
  }
  function inView(el) {
    var r = el.getBoundingClientRect();
    return r.top < window.innerHeight * .92 && r.bottom > 0;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      io.unobserve(e.target);
      var el = e.target;
      if (el.classList.contains('hc-mx-sec')) {
        el.classList.add('is-in');
        // Drop the transform once settled so fixed or sticky children behave normally.
        setTimeout(function () { el.classList.remove('hc-mx-sec', 'is-in'); }, 900);
      }
      if (el.classList.contains('hc-mx-mark')) el.classList.add('is-in');
      if (el.hasAttribute('data-hc-mx-count')) countUp(el);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  /* 1. Sections fade up as they arrive (not the first one, and not ones already on screen). */
  var sections = main.querySelectorAll(':scope > .shopify-section, :scope > div > .shopify-section');
  Array.prototype.forEach.call(sections, function (s, i) {
    if (i === 0 || ownMotion(s) || inView(s) || s.offsetHeight < 40) return;
    s.classList.add('hc-mx-sec');
    io.observe(s);
  });

  /* 2. Highlighter marks draw left to right. Flat background colours become a gradient so they can grow. */
  var MARKS = '.hc-homepage h2 strong, [class*="heading-highlight"], h1 mark, h2 mark, h3 mark';
  Array.prototype.forEach.call(main.querySelectorAll(MARKS), function (m) {
    if (m.closest('[class*="hvp-"], [class*="hkl-"], [class*="hcl-"]')) return;
    var cs = getComputedStyle(m);
    if (cs.backgroundImage === 'none') {
      var c = cs.backgroundColor;
      if (!c || c === 'transparent' || /rgba\(0, 0, 0, 0\)/.test(c)) return;
      m.style.backgroundImage = 'linear-gradient(' + c + ', ' + c + ')';
      m.style.backgroundColor = 'transparent';
    }
    m.classList.add('hc-mx-mark');
    if (inView(m)) requestAnimationFrame(function () { setTimeout(function () { m.classList.add('is-in'); }, 350); });
    else io.observe(m);
  });

  /* 3. Big stat numbers count up once (e.g. +111%, 4.9, 499). Prices never count, and the hero is left as built. */
  var firstSection = sections[0];
  var NUM = /^([+\-−]?)([$£€]?)(\d{1,3}(?:,\d{3})*|\d+)(\.\d+)?(%|x|k|K|M|\+)?(\+)?$/;
  var leaves = main.querySelectorAll('strong, b, span, p, div, h2, h3, h4, dd');
  Array.prototype.forEach.call(leaves, function (el) {
    if (el.children.length || el.closest('[class*="hvp-"], [class*="hkl-"], [class*="hcl-"], [class*="hca"], [data-hcr], [class*="price"], s, del, script, style')) return;
    if (firstSection && firstSection.contains(el)) return;
    var t = el.textContent.trim();
    var m = t.match(NUM);
    if (!m || m[2] || parseFloat(getComputedStyle(el).fontSize) < 22) return;
    var value = parseFloat((m[3] + (m[4] || '')).replace(/,/g, ''));
    if (!value || value > 100000) return;
    el.setAttribute('data-hc-mx-count', t);
    el.style.fontVariantNumeric = 'tabular-nums';
    if (inView(el)) return; // already on screen: leave the real number in place
    io.observe(el);
  });
  function countUp(el) {
    var t = el.getAttribute('data-hc-mx-count');
    var m = t.match(NUM);
    if (!m) return;
    var decimals = m[4] ? m[4].length - 1 : 0;
    var target = parseFloat((m[3] + (m[4] || '')).replace(/,/g, ''));
    var commas = m[3].indexOf(',') > -1;
    var start = performance.now(), dur = 1100;
    el.style.minWidth = el.offsetWidth + 'px';
    function fmt(v) {
      var s = v.toFixed(decimals);
      if (commas) s = s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return m[1] + m[2] + s + (m[5] || '') + (m[6] || '');
    }
    (function step(now) {
      var k = Math.min(1, (now - start) / dur);
      var eased = 1 - Math.pow(1 - k, 3);
      el.textContent = k < 1 ? fmt(target * eased) : t;
      if (k < 1) requestAnimationFrame(step);
      else el.style.minWidth = '';
    })(start);
  }

  /* 4. Yellow call-to-action buttons get a light sweep every few seconds. */
  function isYellow(c) {
    var v = c.match(/\d+(\.\d+)?/g);
    if (!v) return false;
    var r = +v[0], g = +v[1], b = +v[2], a = v[3] === undefined ? 1 : +v[3];
    return a > .8 && r > 235 && g > 190 && g < 240 && b < 120;
  }
  var ctas = document.querySelectorAll('main a, main button, header a');
  var n = 0;
  Array.prototype.forEach.call(ctas, function (el) {
    if (el.closest('[class*="hvp-"], [data-hcr], .hcr') || el.offsetWidth < 90 || el.offsetHeight < 34) return;
    var cs = getComputedStyle(el);
    var yellow = isYellow(cs.backgroundColor) || /254, 212, 9|255, 2(1\d|2\d), (\d|[1-8]\d)\b/.test(cs.backgroundImage);
    if (!yellow) return;
    if (cs.position === 'static') el.style.position = 'relative';
    el.classList.add('hc-mx-cta');
    el.style.setProperty('--hc-mx-delay', (n++ % 4) * 0.7 + 's');
    var sheen = document.createElement('span');
    sheen.className = 'hc-mx-sheen';
    sheen.setAttribute('aria-hidden', 'true');
    el.appendChild(sheen);
  });
})();
